export enum EPlateWellStates {
  Designed = 0,
  Dispensed = 1,
  Imaged = 2,
  Hits = 3,
  Harvested = 4,
}
